// src/config/customerLabels.js
export default {
  product: 'Product',
  project: 'Session',
}